import React from 'react';
import { RowData } from '@tanstack/react-table';
import { useUser } from '../../../hooks/use-user';
import { Button } from 'react-bootstrap';

export const VerifiedCell = ({ verified }: { verified: boolean }) => {
	if (verified) {
		return <span className="glyphicons glyphicons-square-empty-check text-success" />;
	}
	return <span className="glyphicons glyphicons-square-empty-remove text-danger" />;
};

export const InviteCell = (cellInfo: {
	handleInvite: (row: RowData) => void;
	verified: boolean;
	original: RowData;
	buttonText: string;
}) => {
	const { activeCompany } = useUser();
	const disableInvite = activeCompany?.archived;

	return cellInfo.verified ? null : (
		<Button
			variant="outline-secondary"
			type="button"
			disabled={disableInvite}
			onClick={(e) => {
				// Prevent clicking the button from also clicking the row
				e.preventDefault();
				e.stopPropagation();
				cellInfo.handleInvite(cellInfo.original);
			}}>
			{cellInfo.buttonText}
		</Button>
	);
};

export const DeleteCell = (cellInfo: {
	handleDelete: (row: RowData) => void;
	isCurrentUser: boolean;
	original: RowData & { id: number };
}) => {
	if (cellInfo.isCurrentUser) {
		return null;
	}

	return (
		<div style={{ width: 70 }} className="text-center">
			<span
				className="text-center glyphicons glyphicons-bin clickable b-left d-inline-block p-0 chip-glyphicon cursor-pointer"
				id={`remove-user-${cellInfo.original?.id || undefined}`}
				onClick={(e) => {
					e.preventDefault();
					e.stopPropagation();
					cellInfo.handleDelete(cellInfo.original);
				}}
			/>
		</div>
	);
};
